export default __webpack_public_path__ + "static/media/187.1c82b45d.png";